<template>
  <ValidationObserver
    tag="div"
    class="ce-addressForm">
    <div
      v-if="label"
      class="ce-addressForm-label">
      {{ label }}
    </div>

    <div class="ce-addressForm-inner">
      <validated-input
        name="name"
        :value="form.name"
        @input="input"
        :label="$t('addressForm.name')"
        rules="required" />

      <validated-input
        name="street"
        :value="form.street"
        @input="input"
        :label="$t('addressForm.street')"
        rules="required" />

      <div class="xs-flex">
        <validated-input
          class="xs-col-3 xs-pr2"
          name="zipCode"
          :value="form.zipCode"
          @input="input"
          :label="$t('addressForm.zipCode')"
          rules="required" />

        <validated-input
          class="xs-col-9 xs-pl2"
          name="city"
          :value="form.city"
          @input="input"
          :label="$t('addressForm.city')"
          rules="required" />
      </div>

      <ValidationProvider
        :name="$t('addressForm.country')"
        v-slot="{ errors }"
        rules="required"
        mode="eager"
        tag="div"
        class="ce-field">
        <label>
          {{ $t('addressForm.country') }} <span>*</span>
          <span
            v-if="errors.length > 0"
            class="ms-2 ml1 regular ce-colorError">
            {{ errors[0] }}
          </span>
        </label>
        <select
          :value="form.country"
          name="country"
          @change="input">
          <option
            v-for="country in countryOptions"
            :key="country.value"
            :value="country.value">
            {{ country.label }}
          </option>
        </select>
      </ValidationProvider>
    </div>
  </ValidationObserver>
</template>

<script>
import { cloneObject } from 'utils/index';

export default {
  props: {
    label: {
      type: String,
      required: false,
      default: null
    },
    value: {
      type: Object,
      required: true
    }
  },
  created() {
    if (typeof payload === 'object' && typeof payload.countryList === 'object') {
      const countryList = cloneObject(payload.countryList);
      Object.keys(countryList).forEach((countryCode) => {
        this.countryOptions.push({
          label: countryList[countryCode],
          value: countryCode
        });
      });
    }
  },
  data() {
    return {
      form: {
        name: null,
        street: null,
        zipCode: null,
        city: null,
        country: null
      },
      countryOptions: []
    };
  },
  watch: {
    value(newValue) {
      this.form.name = newValue.name;
      this.form.street = newValue.street;
      this.form.zipCode = newValue.zipCode;
      this.form.city = newValue.city;
      this.form.country = newValue.country;
    }
  },
  methods: {
    input(event) {
      this.onInput(event);

      this.$emit('input', {
        ...this.form
      });
    }
  }
};
</script>

<style lang="less">
  @import (reference) "~styles/includes/base";

  .ce-addressForm {
    margin-bottom: @space-3;

    .ce-addressForm-label {
      margin-bottom: @space-2;
      .ms(1);
      .bold;
    }

    .ce-addressForm-inner {
      background: @color-mono-92;
      padding: @space-3;
      border-radius: @border-radius;

      .ce-field {
        input[type="text"], input[type="email"], input[type="number"], input[type="search"], select, textarea {
          background: @color-mono-100;
          border-color: @color-mono-100;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
</style>
